import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(8, 3),
    },
  }),
  { name: 'EmptyMenuState' }
);
